// ***************************************
// tgfHooks
//
// This namespace object deals with the hooks for the client. 
//
// Copyright 2015 Tingly Games B.V.
// Last Changed: 2-11-2015
// ***************************************
// Directives for jslint
/*global tbAudio, tbGame */
/*global flowController, gameController */
/*global window */
// Create the name space object
export var tgfHooks = {};
window["tgfHooks"] = tgfHooks; // Such that is still works after obfuscation
// Initialize the hooks, dealing with obfuscation
tgfHooks.initialize = function () {
    "use strict";
    // Getting information about the client
    if (!tgfHooks["getClientName"]) {
        tgfHooks["getClientName"] = tgfHooks.getClientName;
    }
    if (!tgfHooks["getClientId"]) {
        tgfHooks["getClientId"] = tgfHooks.getClientId;
    }
    if (!tgfHooks["getClientVersion"]) {
        tgfHooks["getClientVersion"] = tgfHooks.getClientVersion;
    }
    if (!tgfHooks["getAnalyticsTracking"]) {
        tgfHooks["getAnalyticsTracking"] = tgfHooks.getAnalyticsTracking;
    }
    if (!tgfHooks["getSiteLocks"]) {
        tgfHooks["getSiteLocks"] = tgfHooks.getSiteLocks;
    }
    if (!tgfHooks["getTimeLock"]) {
        tgfHooks["getTimeLock"] = tgfHooks.getTimeLock;
    }
    if (!tgfHooks["getInitialLanguage"]) {
        tgfHooks["getInitialLanguage"] = tgfHooks.getInitialLanguage;
    }
    if (!tgfHooks["getAvailableLanguages"]) {
        tgfHooks["getAvailableLanguages"] = tgfHooks.getAvailableLanguages;
    }
    if (!tgfHooks["getMoreGamesUrl"]) {
        tgfHooks["getMoreGamesUrl"] = tgfHooks.getMoreGamesUrl;
    }
    if (!tgfHooks["getMoreGamesFunction"]) {
        tgfHooks["getMoreGamesFunction"] = tgfHooks.getMoreGamesFunction;
    }
    if (!tgfHooks["getSplashScreenImage"]) {
        tgfHooks["getSplashScreenImage"] = tgfHooks.getSplashScreenImage;
    }
    if (!tgfHooks["getSplashScreenColor"]) {
        tgfHooks["getSplashScreenColor"] = tgfHooks.getSplashScreenColor;
    }
    if (!tgfHooks["getSplashScreenDuration"]) {
        tgfHooks["getSplashScreenDuration"] = tgfHooks.getSplashScreenDuration;
    }
    if (!tgfHooks["getClientLogo"]) {
        tgfHooks["getClientLogo"] = tgfHooks.getClientLogo;
    }
    if (!tgfHooks["getClientUrl"]) {
        tgfHooks["getClientUrl"] = tgfHooks.getClientUrl;
    }
    if (!tgfHooks["getClientFunction"]) {
        tgfHooks["getClientFunction"] = tgfHooks.getClientFunction;
    }
    if (!tgfHooks["getClientReplace"]) {
        tgfHooks["getClientReplace"] = tgfHooks.getClientReplace;
    }
    // Called during the flow
    if (!tgfHooks["beforeInitializing"]) {
        tgfHooks["beforeInitializing"] = tgfHooks.beforeInitializing;
    }
    if (!tgfHooks["afterInitializing"]) {
        tgfHooks["afterInitializing"] = tgfHooks.afterInitializing;
    }
    if (!tgfHooks["loadingProgress"]) {
        tgfHooks["loadingProgress"] = tgfHooks.loadingProgress;
    }
    if (!tgfHooks["afterLoading"]) {
        tgfHooks["afterLoading"] = tgfHooks.afterLoading;
    }
    if (!tgfHooks["beforeTitleScreen"]) {
        tgfHooks["beforeTitleScreen"] = tgfHooks.beforeTitleScreen;
    }
    if (!tgfHooks["beforeLevelScreen"]) {
        tgfHooks["beforeLevelScreen"] = tgfHooks.beforeLevelScreen;
    }
    if (!tgfHooks["beforePlay"]) {
        tgfHooks["beforePlay"] = tgfHooks.beforePlay;
    }
    if (!tgfHooks["playStart"]) {
        tgfHooks["playStart"] = tgfHooks.playStart;
    }
    if (!tgfHooks["playWon"]) {
        tgfHooks["playWon"] = tgfHooks.playWon;
    }
    if (!tgfHooks["playLost"]) {
        tgfHooks["playLost"] = tgfHooks.playLost;
    }
    if (!tgfHooks["playStage"]) {
        tgfHooks["playStage"] = tgfHooks.playStage;
    }
    if (!tgfHooks["playEnd"]) {
        tgfHooks["playEnd"] = tgfHooks.playEnd;
    }
    if (!tgfHooks["playRestart"]) {
        tgfHooks["playRestart"] = tgfHooks.playRestart;
    }
    if (!tgfHooks["stepGame"]) {
        tgfHooks["stepGame"] = tgfHooks.stepGame;
    }
    if (!tgfHooks["stepPlay"]) {
        tgfHooks["stepPlay"] = tgfHooks.stepPlay;
    }
    if (!tgfHooks["gameCompleted"]) {
        tgfHooks["gameCompleted"] = tgfHooks.gameCompleted;
    }
    // TODO: Add other hooks here
    // Retrieve the data for the client using the different calls and putting it in the settings
    tgfHooks.retrieveInfo();
};
// Retrieve all the information from the client
tgfHooks.retrieveInfo = function () {
    "use strict";
    tgfSettings.client = tgfSettings.client || {};
    if (tgfHooks["getClientName"]) {
        tgfSettings.client.name = tgfHooks.execute("getClientName");
    }
    if (tgfHooks["getClientId"]) {
        tgfSettings.client.id = tgfHooks.execute("getClientId");
    }
    if (tgfHooks["getClientVersion"]) {
        tgfSettings.client.version = tgfHooks.execute("getClientVersion");
    }
    if (tgfHooks["getAnalyticsTracking"]) {
        tgfSettings.client.analyticsTracking = tgfHooks.execute("getAnalyticsTracking");
    }
    if (tgfHooks["getInitialLanguage"]) {
        tgfSettings.client.initialLanguage = tgfHooks.execute("getInitialLanguage");
    }
    if (tgfHooks["getAvailableLanguages"]) {
        tgfSettings.client.availableLanguages = tgfHooks.execute("getAvailableLanguages");
    }
    if (tgfHooks["getMoreGamesUrl"]) {
        tgfSettings.client.moreGameUrl = tgfHooks.execute("getMoreGamesUrl");
    }
    if (tgfHooks["getMoreGamesFunction"]) {
        tgfSettings.client.moreGamesFunction = tgfHooks.execute("getMoreGamesFunction");
    }
    if (tgfHooks["getSplashScreenImage"]) {
        tgfSettings.client.splashScreenImage = tgfHooks.execute("getSplashScreenImage");
    }
    if (tgfHooks["getSplashScreenColor"]) {
        tgfSettings.client.splashScreenColor = tgfHooks.execute("getSplashScreenColor");
    }
    if (tgfHooks["getSplashScreenDuration"]) {
        tgfSettings.client.splashScreenDuration = tgfHooks.execute("getSplashScreenDuration");
    }
    if (tgfHooks["getClientLogo"]) {
        tgfSettings.client.logo = tgfHooks.execute("getClientLogo");
    }
    if (tgfHooks["getClientUrl"]) {
        tgfSettings.client.logoUrl = tgfHooks.execute("getClientUrl");
    }
    if (tgfHooks["getClientFunction"]) {
        tgfSettings.client.logoFunction = tgfHooks.execute("getClientFunction");
    }
    if (tgfHooks["getClientReplace"]) {
        tgfSettings.client.logoReplace = tgfHooks.execute("getClientReplace");
    }
};
// ***************************************
// Executing hooks, to be used in the flow object
// ***************************************
// Execute a hook
tgfHooks.execute = function (name, arg0, arg1, arg2, arg3, arg4) {
    "use strict";
    if (tgfHooks[name]) {
        return tgfHooks[name](arg0, arg1, arg2, arg3, arg4);
    }
    return undefined;
};
// ***************************************
// Dealing with pausing and resuming
// The client hooks can call these special hook functions to pause and resume
// It works both with obfuscated and non-obfuscated code
// ***************************************
// Pause the audio
tgfHooks.pauseAudio = function () {
    "use strict";
    tbAudio.pause("master");
};
// Resume the audio
tgfHooks.resumeAudio = function () {
    "use strict";
    tbAudio.resume("master");
};
// Pause the flow
tgfHooks.pauseFlow = function () {
    "use strict";
    flowController.pauseFlow();
};
// Resume the flow
tgfHooks.resumeFlow = function () {
    "use strict";
    tbGame.clearClickEvents();
    tbGame.clearTouchEvents();
    tbGame.clearKeyboardEvents();
    flowController.resumeFlow(false);
};
// Pause the game
tgfHooks.pauseGame = function () {
    "use strict";
    gameController.pausePlay();
};
// Resume the game
tgfHooks.resumeGame = function () {
    "use strict";
    tbGame.clearClickEvents();
    tbGame.clearTouchEvents();
    tbGame.clearKeyboardEvents();
    gameController.resumePlay(false);
};
// Pause everything
tgfHooks.pauseAll = function () {
    "use strict";
    tgfHooks.pauseFlow();
    tgfHooks.pauseGame();
    tgfHooks.pauseAudio();
};
// Resume everything
tgfHooks.resumeAll = function () {
    "use strict";
    tgfHooks.resumeFlow();
    tgfHooks.resumeGame();
    tgfHooks.resumeAudio();
};
// Deal with obfuscation
if (!tgfHooks["pauseFlow"]) {
    tgfHooks["pauseFlow"] = tgfHooks.pauseFlow;
}
if (!tgfHooks["resumeFlow"]) {
    tgfHooks["resumeFlow"] = tgfHooks.resumeFlow;
}
if (!tgfHooks["pauseGame"]) {
    tgfHooks["pauseGame"] = tgfHooks.pauseGame;
}
if (!tgfHooks["resumeGame"]) {
    tgfHooks["resumeGame"] = tgfHooks.resumeGame;
}
if (!tgfHooks["pauseAudio"]) {
    tgfHooks["pauseAudio"] = tgfHooks.pauseAudio;
}
if (!tgfHooks["resumeAudio"]) {
    tgfHooks["resumeAudio"] = tgfHooks.resumeAudio;
}
if (!tgfHooks["pauseAll"]) {
    tgfHooks["pauseAll"] = tgfHooks.pauseAll;
}
if (!tgfHooks["resumeAll"]) {
    tgfHooks["resumeAll"] = tgfHooks.resumeAll;
}
// ***************************************
// Converting and loading images
// ***************************************
// Converts an HTML image to a tbImage
tgfHooks.convertImage = function (name, image) {
    "use strict";
    return tbImageFromImage(name, image, image.width, image.height, 0, 0);
};
// Converts an HTML image file into a tbImage (will be asynchronous)
tgfHooks.convertImageFile = function (name, fname, width, height) {
    "use strict";
    return tbImageLoad(name, fname, width, height, 0, 0);
};
// Deal with obfuscation
if (!tgfHooks["convertImage"]) {
    tgfHooks["convertImage"] = tgfHooks.convertImage;
}
if (!tgfHooks["convertImageFile"]) {
    tgfHooks["convertImageFile"] = tgfHooks.convertImageFile;
}
// ***************************************
// Useful information for the hooks
// ***************************************
// Returns the id of the game
tgfHooks.gameId = function () {
    "use strict";
    return tgfSettings.game.id;
};
// Deal with obfuscation
if (!tgfHooks["gameId"]) {
    tgfHooks["gameId"] = tgfHooks.gameId;
}
// TODO: Add info about scores, etc.
// TODO: Add analytics calls
// TODO: Add possibility to reset/set the highscore, etc.
// ***************************************
// The default empty information hooks that better be overriden by the client
// ***************************************
// Called to get the name of the client.
tgfHooks.getClientName = function () {
    "use strict";
    return "Unknown";
};
// Called to get the unique id of the client.
tgfHooks.getClientId = function () {
    "use strict";
    return "unknown";
};
// Called to get the version of the client hooks.
tgfHooks.getClientVersion = function () {
    "use strict";
    return "1.0";
};
// Called to get whether we track analytics for this client
tgfHooks.getAnalyticsTracking = function () {
    "use strict";
    return true;
};
// Called to get an array with the site locks (MD5 hashed) for the origins for this client
// (An origin is for example: "http://www.google.nl")
// When undefined, the game won't run, except in text mode
tgfHooks.getSiteLocks = function () {
    "use strict";
    return undefined;
};
// Called to get a time lock (date). When undefined the game will always run.
tgfHooks.getTimeLock = function () {
    "use strict";
    return undefined;
};
// Called to get the initial language for this client. Undefined for default.
tgfHooks.getInitialLanguage = function () {
    "use strict";
    return undefined;
};
// Called to get an array of the available languages for this client. Undefined for all.
tgfHooks.getAvailableLanguages = function () {
    "use strict";
    return undefined;
};
// Called to get the more games url.
tgfHooks.getMoreGamesUrl = function () {
    "use strict";
    return undefined;
};
// Called to get the function for more games.
tgfHooks.getMoreGamesFunction = function () {
    "use strict";
    return undefined;
};
// Called to get a splash screen tbImage or tbSurface.
tgfHooks.getSplashScreenImage = function () {
    "use strict";
    return undefined;
};
// Called to get a splash screen background color
tgfHooks.getSplashScreenColor = function () {
    "use strict";
    return undefined;
};
// Called to get a splash screen duration in seconds
tgfHooks.getSplashScreenDuration = function () {
    "use strict";
    return undefined;
};
// Called to get a client logo tbImage or tbSurface.
tgfHooks.getClientLogo = function () {
    "use strict";
    return undefined;
};
// Called to get a client url that is used when clicking the client image.
tgfHooks.getClientUrl = function () {
    "use strict";
    return undefined;
};
// Called to get a client function that is called when clicking the client image.
tgfHooks.getClientFunction = function () {
    "use strict";
    return undefined;
};
// Called to see whether the client logo should replace our logo
tgfHooks.getClientReplace = function () {
    "use strict";
    return undefined;
};
// ***************************************
// The default empty flow hooks that can be overriden by the client
// ***************************************
// Called before any initialization takes place. Settings for flow, theme, game, and client have been
// filled in. This is the default place to initialize client API's and request/set-up
// logo's and/splash screen images for the loading and start page.
tgfHooks.beforeInitializing = function () {
    "use strict";
};
// Called after the framework has been initialized. Also all images with the "start" moment have now
// been loaded. The other loading has not yet happened not has the load screen been shown. This
// can be used to draw splash-screens of which images are included in the "start" sprite sheets
tgfHooks.afterInitializing = function () {
    "use strict";
};
// Called every step during loading to inform of loading progress. Parameter: loading progress in percentages
tgfHooks.loadingProgress = function (progress) {
    "use strict";
};
// Called when loading has finished and start screen (i.e. buttons and logo) are about to be shown
tgfHooks.afterLoading = function () {
    "use strict";
};
// Called each time before the tile screen is shown, Here you could show an ad,
// or save some statistics.
tgfHooks.beforeTitleScreen = function () {
    "use strict";
};
// Called each time before the level selection screen is shown, Here you could show an ad,
// or save some statistics.
tgfHooks.beforeLevelScreen = function () {
    "use strict";
};
// Called each time a play is started, before any game related stuff is shown or initialized
tgfHooks.beforePlay = function () {
    "use strict";
};
// Called each time a play is started, just before the start game screen dialog is shown
// mode indicated the mode starting with 1 (undefined if no mode)
// level indicates the level starting with 1 (undefined if no levels)
// Return the action to take ("dialog", "nodialog") Default is to show the dialog
tgfHooks.playStart = function (mode, level) {
    "use strict";
};
// Called each time a play is won. Score, time, stars, and moves are the results of the play
// They might be undefined if this information is not relevant for the game
// This is called just before our own end of play dialog is shown
// Return the action to take ("dialog", "title", "level", "restart", "next") Default is to show the dialog
tgfHooks.playWon = function (score, time, stars, moves) {
    "use strict";
};
// Called each time a play is lost.
// This is called just before our own end of play dialog is shown
// Return the action to take ("dialog", "title", "level", "restart", "next") Default is to show the dialog
tgfHooks.playLost = function () {
    "use strict";
};
// Called each time a stage is completed. stage is the number of the stage (starting with 1)
// Score, time, stars, and moves are the results of the stage
// They might be undefined if this information is not relevant for the game
// This is called just before our own stage completed dialog is shown
// Return the action to take ("dialog", "nodialog") Default is to show the dialog
tgfHooks.playStage = function (stage, score, time, stars, moves) {
    "use strict";
};
// Called at the end of the play, when  everything is cleaned up. (also when the player quit the game through the menu)
// quit indicates whether the player quit through the menu and, hence,  did not finish the play
// This is the ideal place to show ads
tgfHooks.playEnd = function (quit) {
    "use strict";
};
//Called when game restarted
tgfHooks.playRestart = function () {
    "use strict";
};
// Called each step during the running of the game (also during the framework dialogs)
tgfHooks.stepGame = function (timePassed) {
    "use strict";
};
// Called each step during the playing only
tgfHooks.stepPlay = function (timePassed) {
    "use strict";
};
// Called when the game is completed and the game complete screen is shown (so after playEnd)
// Does only happen for level based games
tgfHooks.gameCompleted = function () {
    "use strict";
};
import { flowController, gameController } from "../../../game_theme/flow_fb/flowController";
import { tbAudio } from "../../engine/tbAudio";
import { tbGame } from "../../engine/tbGame";
import { tbImageFromImage } from "../tbImageFromImage";
import { tgfDictionary } from "../tgfDictionary";
import { tgfSettings } from "../tgfSettings";
// ******************************
// Tingly Builder JavaScript file
// ******************************
import { fbInstant } from "./FBInstantGame";
tgfHooks.beforeInitializing = function () {
    "use strict";
};
// Called after the framework has been initialized. Also all images with the "start" moment have now
// been loaded. The other loading has not yet happened not has the load screen been shown. This
// can be used to draw splash-screens of which images are included in the "start" sprite sheets
tgfHooks.afterInitializing = function () {
    "use strict";
    return;
    fbInstant.init();
};
// Say the player gets a phone call or switches apps or something, this is triggered
tgfHooks.onPause = function (callback) {
    "use strict";
    return callback();
    fbInstant.onPause(callback);
};
// Gives a Facebook dialog where you can switch to a different context
tgfHooks.switchContext = function (context, call, onFail) {
    "use strict";
    return call();
    fbInstant.switchContext(context, call, onFail);
};
// Gives a Facebook dialog where you can choose a context
tgfHooks.chooseContext = function (call, onFail, options) {
    "use strict";
    return call();
    fbInstant.chooseContext(call, onFail, options);
};
// Call this to share something like an invite or request
// Use this ONLY if you want share a custom image from say a surface, otherwise use shareScreenshot
// shareType can be SHARE for regular and legacy screenshot sharing
// INVITE, CHALLENGE and REQUEST are new and experimental
tgfHooks.share = function (call, shareType, image, message, data, onFail) {
    "use strict";
    return call();
    fbInstant.share(call, shareType, image, message, data, onFail);
};
tgfHooks.shareScreenshot = function (call, shareType, canvasIndex, message, data, onFail) {
    "use strict";
    return call();
    fbInstant.share(call, shareType, fbInstant.getScreenShot(canvasIndex ? canvasIndex : 0), message, data, onFail);
};
tgfHooks.updateAsync = function (call, template, image, buttonText, message, data, onFail, strategy) {
    "use strict";
    return call();
    fbInstant.updateAsync(call, template, image, buttonText, message, data, onFail, strategy);
};
tgfHooks.updateAsyncScreenshot = function (call, template, canvasIndex, buttonText, message, data, onFail, strategy) {
    "use strict";
    return call();
    fbInstant.updateAsync(call, template, fbInstant.getScreenShot(canvasIndex ? canvasIndex : 0), buttonText, message, data, onFail, strategy);
};
// Called every step during loading to inform of loading progress. Parameter: loading progress in percentages
tgfHooks.loadingProgress = function (progress) {
    "use strict";
    return;
    fbInstant.setProgress(progress);
};
// Called when loading has finished and start screen (i.e. buttons and logo) are about to be shown
tgfHooks.afterLoading = function () {
    "use strict";
    return;
    fbInstant.loadingCompleted();
};
// Called each time before the tile screen is shown, Here you could show an ad,
// or save some statistics.
tgfHooks.beforeTitleScreen = function () {
    "use strict";
};
// Called each time before the level selection screen is shown, Here you could show an ad,
// or save some statistics.
tgfHooks.beforeLevelScreen = function () {
    "use strict";
};
// Called each time a play is started, before any game related stuff is shown or initialized
tgfHooks.beforePlay = function () {
    "use strict";
};
// Called each time a play is started, just before the start game screen dialog is shown
// mode indicated the mode starting with 1 (undefined if no mode)
// level indicates the level starting with 1 (undefined if no levels)
// Return the action to take ("dialog", "nodialog") Default is to show the dialog
tgfHooks.playStart = function (mode, level) {
    "use strict";
};
// Needs custom back end!
// Called each time a play is won. Score, time, stars, and moves are the results of the play
// They might be undefined if this information is not relevant for the game
// This is called just before our own end of play dialog is shown
// Return the action to take ("dialog", "title", "level", "restart", "next") Default is to show the dialog
tgfHooks.playWon = function (score, time, stars, moves) {
    "use strict";
    return;
    fbInstant.setScore(score);
};
// Called each time a play is lost.
// This is called just before our own end of play dialog is shown
// Return the action to take ("dialog", "title", "level", "restart", "next") Default is to show the dialog
tgfHooks.playLost = function (score) {
    "use strict";
    //TODO put score in the actuall flow
    return;
    var _score = 0;
    if (score) {
        _score = score;
    }
    fbInstant.setScore(_score);
};
tgfHooks.gameOver = function (call) {
    "use strict";
    return call();
    fbInstant.quit(call);
};
tgfHooks.logEvent = function (event, sum, params) {
    "use strict";
    return;
    fbInstant.logEvent(event, sum, params);
};
// Depricated, needs custom  back end!
// Called each time a stage is completed. stage is the number of the stage (starting with 1)
// Score, time, stars, and moves are the results of the stage
// They might be undefined if this information is not relevant for the game
// This is called just before our own stage completed dialog is shown
// Return the action to take ("dialog", "nodialog") Default is to show the dialog
tgfHooks.playStage = function (stage, score, time, stars, moves) {
    "use strict";
    return;
    fbInstant.setScore(score);
};
// Called at the end of the play, when  everything is cleaned up. (also when the player quit the game through the menu)
// quit indicates whether the player quit through the menu and, hence,  did not finish the play
// This is the ideal place to show ads
tgfHooks.playEnd = function (quit) {
    "use strict";
};
//Called when game restarted
tgfHooks.playRestart = function () {
    "use strict";
};
// Called each step during the running of the game (also during the framework dialogs)
tgfHooks.stepGame = function (timePassed) {
    "use strict";
};
// Called each step during the playing only
tgfHooks.stepPlay = function (timePassed) {
    "use strict";
};
// Called when the game is completed and the game complete screen is shown (so after playEnd)
// Does only happen for level based games
tgfHooks.gameCompleted = function () {
    "use strict";
};
tgfHooks.getSiteLocks = function () {
    "use strict";
    // return configuration_general.siteLock.domains;
    return [];
};
tgfHooks.getAnalyticsTracking = function () {
    "use strict";
    return false;
};
// Use this to retrieve the current state of the game
// (from other players having done their stuff / turn)
tgfHooks.getEntryPointData = function () {
    "use strict";
    return {};
    return fbInstant.getEntryPointData();
};
tgfHooks.getEntryPointAsync = function () {
    "use strict";
    return {};
    return fbInstant.getEntryPointAsync();
};
// Use this to push the current state of the game to other players
// Not intended for realtime multiplayer
// Blob data is restricted to 1kb 
tgfHooks.setSessionData = function (data) {
    "use strict";
    return;
    fbInstant.setSessionData(data);
};
tgfHooks.setStartCallback = function (call) {
    "use strict";
    tgfHooks.startCall = call;
};
tgfHooks.getStartCallback = function () {
    "use strict";
    return tgfHooks.startCall;
};
tgfHooks.showAd = function (callback) {
    "use strict";
    //TODO tis should be able to show ads from FB
    if (callback) {
        callback();
    }
};
tgfHooks.saveGdprData = function (data, onSuccess, onFail) {
    "use strict";
    return onSuccess();
    fbInstant.gdprSaveData(data, onSuccess, onFail);
};
tgfHooks.loadGdprData = function (onSuccess, onFail) {
    "use strict";
    return onSuccess();
    fbInstant.gdprLoadData(onSuccess, onFail);
};
tgfHooks.saveExtraData = function (file) {
    "use strict";
    return;
    fbInstant.extraSaveData(file);
};
tgfHooks.getExtraData = function () {
    "use strict";
    return fbInstant.extraData;
};
tgfHooks.updateExtraData = function (data) {
    "use strict";
    return;
    fbInstant.extraData = data;
};
tgfHooks.getConnectedPlayersID = function (call, fail) {
    "use strict";
    return call([]);
    fbInstant.loadFriendsIDs(call, fail);
    //return fbInstant.otherPlayerIDs;
};
tgfHooks.getProfileImage = function () {
    "use strict";
    return "";
    return fbInstant.playerImage;
};
tgfHooks.getPlayerID = function () {
    "use strict";
    return "Bas was here";
    return fbInstant.getPlayerID();
};
tgfHooks.getDevice = function () {
    "use strict";
    return "unknown";
    return fbInstant.getDevice();
};
tgfHooks.getPlayerName = function () {
    "use strict";
    return tgfDictionary.getText("challengeEndScreenName_you");
    return fbInstant.getPlayerName();
};
tgfHooks.getLocale = function () {
    "use strict";
    return "en_US";
    return fbInstant.getLocale();
};
tgfHooks.getContextID = function () {
    "use strict";
    return "thisisnotfacebook";
    return fbInstant.getContextID();
};
tgfHooks.getContextType = function () {
    "use strict";
    return "thisisnotfacebook";
    return fbInstant.getContextType();
};
tgfHooks.getPlayerImageUrl = function () {
    "use strict";
    return "thisisnotfacebook";
    return fbInstant.getPlayerImageURL();
};
tgfHooks.getContextPlayers = function (callback, onFail) {
    "use strict";
    return callback([]);
    fbInstant.getContextPlayers(callback, onFail);
};
tgfHooks.getPlayerInfo = function (callback, payload) {
    "use strict";
    return callback({});
    fbInstant.getPlayerInfo(callback, payload);
};
tgfHooks.isSizeBetween = function (min, max) {
    "use strict";
    return false;
    return fbInstant.isSizeBetween(min, max);
};
tgfHooks.areAdsSupported = function () {
    "use strict";
    return false;
    return fbInstant.areAdsSupported();
};
tgfHooks.prepareAd = function (placementID) {
    "use strict";
    return;
    fbInstant.prepareAd(placementID);
};
tgfHooks.playAd = function (context, callback, placementID) {
    "use strict";
    return callback();
    fbInstant.playAd(context, callback, placementID);
};
tgfHooks.isPlayingAd = function () {
    "use strict";
    return false;
    return fbInstant.isPlayingAd();
};
tgfHooks.createContext = function (call, id, fail) {
    "use strict";
    return call();
    fbInstant.createContext(call, id, fail);
};
tgfHooks.createHomeScreenButton = function () {
    "use strict";
    return;
    return fbInstant.createHomeScreenButton();
};
tgfHooks.canCreateShortcut = function () {
    return Promise.resolve(false);
    return fbInstant.canCreateShortcutAsync();
};
